import {
  Wifi,
  Sparkles,
  Layers,
  Car,
  Wind,
  Shirt,
  AirVent,
  Flame,
  PawPrint,
} from "lucide-react";
import { FadeUp, SectionHeading } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const ICONS = [Wifi, Sparkles, Layers, Car, Wind, Shirt, AirVent, Flame, PawPrint];

export default function Services() {
  const { T } = useLang();
  return (
    <section id="servicios" data-testid="services-section" className="relative bg-federasol-blush/60 py-14 md:py-24">
      <div className="container-x">
        <SectionHeading
          eyebrow={T.services.eyebrow}
          title={T.services.title}
          subtitle={T.services.subtitle}
        />

        <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3">
          {T.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp key={s.t} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`other-service-${i}`}
                  className="group flex h-full items-start gap-3 rounded-2xl border border-federasol-terra/10 bg-federasol-cream/80 p-3.5 transition-all duration-500 ease-soft hover:border-federasol-rose/40 hover:bg-white hover:shadow-[0_18px_40px_-18px_rgba(166,93,71,0.28)] sm:gap-4 sm:p-5"
                >
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-federasol-blush text-federasol-terra transition-colors duration-500 group-hover:bg-federasol-rose group-hover:text-white sm:h-11 sm:w-11">
                    <Icon className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={1.6} />
                  </div>
                  <div>
                    <h3 className="font-serif text-sm font-semibold leading-snug text-federasol-cocoa sm:text-lg">
                      {s.t}
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-federasol-muted sm:text-sm">{s.d}</p>
                    {s.note && (
                      <p className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-federasol-terra sm:mt-1.5 sm:text-xs">
                        {s.note}
                      </p>
                    )}
                  </div>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
